<template>
  <div id="activity">
    <Header :title="title">
      <template slot="right">
        <div class="mybarRight" v-on:click="toSearch">
          <span class="iconfont icon-sousuo f12 color_999" />
        </div>
      </template>
    </Header>

    <main class="MainCon bottom0" :class="activityList.style" id="MainCon">
      <div v-if="loadingStatus">
        <p class="myimg" v-on:click="toBanner"><img v-bind:src="activityList.banner_wap" /></p>
        <p class="tc mt10" v-show="activityBrand">
          <span class="sessionActivityTitle1" v-show="activityList.style === 'red'">品牌店铺</span>
          <span class="sessionActivityTitle2" v-show="activityList.style === 'yellow'">品牌店铺</span>
          <span class="sessionActivityTitle3" v-show="activityList.style === 'blue'">品牌店铺</span>
          <span class="sessionActivityTitle4" v-show="activityList.style === 'green'">品牌店铺</span>
          <span class="sessionActivityTitle5" v-show="activityList.style === 'orange'">品牌店铺</span>
        </p>
        <div class="ml7 mr7 mt10" v-show="activityBrand">
          <div class="indexMenuBoxList flexBetween">
            <div class="flexBox-cell-48 myimg mb5" v-on:click="toUrl(item.url)" v-for="(item,index) in activityImgList"
                 :key="index"><img v-bind:src="item.image" /></div>
          </div>
        </div>
        <p class="tc mt10" v-show="activityRec">
          <span class="sessionActivityTitle1" v-show="activityList.style === 'red'">今日热卖</span>
          <span class="sessionActivityTitle2" v-show="activityList.style === 'yellow'">今日热卖</span>
          <span class="sessionActivityTitle3" v-show="activityList.style === 'blue'">今日热卖</span>
          <span class="sessionActivityTitle4" v-show="activityList.style === 'green'">今日热卖</span>
          <span class="sessionActivityTitle5" v-show="activityList.style === 'orange'">今日热卖</span>
        </p>
        <div class="ml7 mr7 mt10" v-show="activityRec">
          <div class="goodInfoBoxList flexBetween">
            <div class="indexGoodBlock mb5 flexBox-cell-48 rel" v-for="(item, index) in activityRecList" :key="index">
              <div class="elevenBuyTipBg" v-show="item.presale_deposit"><img src="@/assets/images/1111tipBg.png" />
              </div>

              <template v-if="app.template.type === '92fanli'">
                <NTfanliGoodsListItem :style-name="app.template.style" :goods-data="item" />
              </template>
              <template v-else-if="app.template.type === 'damai'">
                <DamaiGoodsListItem :style-name="app.template.style" :goods-data="item" />
              </template>
              <template v-else>
                <IfanliGoodsListItem :style-name="app.template.style" :goods-data="item" />
              </template>

            </div>
          </div>
        </div>

        <div class="ml7 mr7 mt10" v-for="(item, index) in activityList.list" :key="index">
          <p class="tc">
            <span class="sessionActivityTitle1" v-on:click="toTopGoodsList(item.category_name)"
                  v-show="activityList.style === 'red'">{{ item.category_name }}</span>
            <span class="sessionActivityTitle2" v-on:click="toTopGoodsList(item.category_name)"
                  v-show="activityList.style === 'yellow'">{{ item.category_name }}</span>
            <span class="sessionActivityTitle3" v-on:click="toTopGoodsList(item.category_name)"
                  v-show="activityList.style === 'blue'">{{ item.category_name }}</span>
            <span class="sessionActivityTitle4" v-on:click="toTopGoodsList(item.category_name)"
                  v-show="activityList.style === 'green'">{{ item.category_name }}</span>
            <span class="sessionActivityTitle5" v-on:click="toTopGoodsList(item.category_name)"
                  v-show="activityList.style === 'orange'">{{ item.category_name }}</span>
          </p>
          <div class="goodInfoBoxList flexBetween mt10">
            <div class="indexGoodBlock mb5 flexBox-cell-48 rel" v-for="(item,index) in item.goodsList.list"
                 :key="index">
              <div class="elevenBuyTipBg" v-show="item.presale_deposit"><img src="../assets/images/1111tipBg.png" />
              </div>

              <template v-if="app.template.type === '92fanli'">
                <NTfanliGoodsListItem :style-name="app.template.style" :goods-data="item" />
              </template>
              <template v-else-if="app.template.type === 'damai'">
                <DamaiGoodsListItem :style-name="app.template.style" :goods-data="item" />
              </template>
              <template v-else>
                <IfanliGoodsListItem :style-name="app.template.style" :goods-data="item" />
              </template>

            </div>
          </div>
        </div>
        <p class="tc mt10 mb20">
          <span class="sessionActivityTitle1" v-on:click="toAll" v-show="activityList.style === 'red'">全部会场</span>
          <span class="sessionActivityTitle2" v-on:click="toAll" v-show="activityList.style === 'yellow'">全部会场</span>
          <span class="sessionActivityTitle3" v-on:click="toAll" v-show="activityList.style === 'blue'">全部会场</span>
          <span class="sessionActivityTitle4" v-on:click="toAll" v-show="activityList.style === 'green'">全部会场</span>
          <span class="sessionActivityTitle5" v-on:click="toAll" v-show="activityList.style === 'orange'">全部会场</span>
        </p>
      </div>
      <div v-else>
        <div class="sessionActivityBanner-loading mt1"></div>
        <p class="tc mt10"><span class="sessionActivityTitle-loading"></span></p>
        <div class="ml7 mr7 mt7">
          <div class="indexMenuBoxList flexBetween">
            <div class="flexBox-cell-48 mb5"><span class="sessionActivityBlock-loading"></span></div>
            <div class="flexBox-cell-48 mb5"><span class="sessionActivityBlock-loading"></span></div>
            <div class="flexBox-cell-48 mb5"><span class="sessionActivityBlock-loading"></span></div>
            <div class="flexBox-cell-48 mb5"><span class="sessionActivityBlock-loading"></span></div>
          </div>
        </div>
        <p class="tc mt10"><span class="sessionActivityTitle-loading"></span></p>
        <div class="ml7 mr7 mt7">
          <div class="goodInfoBoxList flexBetween">
            <div class="indexGoodBlock mb5 flexBox-cell-48">
              <div class="ml5 mr5">
                <div class="loading-goodInfoBlockImg"></div>
                <p class="loading-barblock mt7"></p>
                <div class="flexBox flexBetween mt7">
                  <div class="loading-block-36"></div>
                  <div class="loading-block-36"></div>
                </div>
                <div class="flexBox mt7 mb5">
                  <div class="loading-block"></div>
                  <div class="loading-block ml5"></div>
                </div>
              </div>
            </div>
            <div class="indexGoodBlock mb5 flexBox-cell-48">
              <div class="ml5 mr5">
                <div class="loading-goodInfoBlockImg"></div>
                <p class="loading-barblock mt7"></p>
                <div class="flexBox flexBetween mt7">
                  <div class="loading-block-36"></div>
                  <div class="loading-block-36"></div>
                </div>
                <div class="flexBox mt7 mb5">
                  <div class="loading-block"></div>
                  <div class="loading-block ml5"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <div class="goTopBtn"><img v-if="btnFlag" src="@/assets/images/backTop.png" v-on:click="toTop"></div>
  </div>
</template>

<script>
import NTfanliGoodsListItem from './92fanli/TopGoodsListItem';
import DamaiGoodsListItem from './damai/TopGoodsListItem';
import IfanliGoodsListItem from './ifanli/TopGoodsListItem';
import Header from '@/components/Header';
import {mapState} from 'vuex';
import {isMobile} from "@/libs/utils";
import {appService} from "@/services/app";

export default {
  components: {
    NTfanliGoodsListItem,
    DamaiGoodsListItem,
    IfanliGoodsListItem,
    Header
  },
  data() {
    return {
      title: '分会场',
      activityList: {},
      activityImgList: [],
      activityRecList: [],
      loadingStatus: false,
      activityBrand: false,
      activityRec: false,
      venue_branch_id: 0,
      btnFlag: false,
    }
  },
  computed: {
    ...mapState(['app'])
  },
  created() {
    this.venue_branch_id = this.$route.query.id;

    if (!isMobile()) {
      window.location.href = window.location.origin + '/activity';
    }

    this.fetchActivityBranch();
    this.fetchActivityRecList();
  },
  updated() {
    document.getElementById('MainCon').addEventListener('scroll', this.scrollToTop)
  },
  methods: {
    fetchActivityBranch: function () {
      let self = this;

      appService.fetchActivityBranch({venueBranchId: self.venue_branch_id}).then((res) => {
        let {code, data} = res;
        if (code === 1) {
          self.loadingStatus = true;
          self.activityList = data;
          if (self.activityList.name) {
            self.title = self.activityList.name + self.title;
          }
        }
      });
    },
    fetchActivityRecList: function () {
      let self = this;

      appService.fetchActivityRecList({venueBranchId: self.venue_branch_id}).then((res) => {
        let {code, data} = res;
        if (code === 1) {
          self.activityRecList = data;
          if (self.activityRecList.length > 0) {
            self.activityRec = true;
          }
        }
      });
    },
    toBanner: function () {
      window.location.href = this.activityList.banner_wap_url;
    },
    toUrl: function (url) {
      if (url) window.location.href = url;
    },
    toAll: function () {
      this.$router.push({name: 'activity-all'});
    },
    toSearch: function () {
      this.$router.push({name: 'search'});
    },
    scrollToTop: function () {
      this.btnFlag = document.getElementById('MainCon').scrollTop > 180;
    },
    toTop: function () {
      document.getElementById('MainCon').scrollTop = 0;
    },
  }
}
</script>

<style scoped>

</style>
